var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"px-4 py-2 bg-gray-300 text-gray-500 font-semibold rounded hover:bg-gray-500 hover:text-gray-100 mr-4",on:{"click":function($event){return _vm.$router.back()}}},[_vm._t("default",function(){return [_vm._v(" Cancel ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }